import { render, staticRenderFns } from "./ModuleSection.vue?vue&type=template&id=8eb81d94&scoped=true&"
import script from "./ModuleSection.vue?vue&type=script&lang=js&"
export * from "./ModuleSection.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSection.vue?vue&type=style&index=0&id=8eb81d94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb81d94",
  null
  
)

export default component.exports